export default __webpack_public_path__ + "static/the-original-cop@2x-2848db75ba7bf97318cd623e9e75110d.png";